import { keepPreviousData, useQueries } from '@tanstack/react-query';

import type { TMemberFilterQuery } from '@/services/members';

import { MEMBER_KEYS } from '@/constants/queryKeys';
import { errorUtils } from '@/services/errors';
import { membersService } from '@/services/members';
import { useStaffSession } from '@/hooks/auth';

type TMemberCountFacet = {
  key: string;
  query: TMemberFilterQuery;
};

type TMemberCounts = Record<string, number | undefined>;

const useMemberCounts = (
  facets: readonly TMemberCountFacet[],
  isEnabled: boolean = true,
): TMemberCounts => {
  const { data: session } = useStaffSession();

  const results = useQueries({
    queries: facets.map(facet => ({
      queryKey: MEMBER_KEYS.count(facet.query),
      queryFn: async () => errorUtils.unwrap(await membersService.countMembers(facet.query)),
      enabled: isEnabled && session?.stage === 'ready',
      placeholderData: keepPreviousData,
    })),
  });

  return Object.fromEntries(facets.map((facet, index) => [facet.key, results[index]?.data]));
};

export type {
  TMemberCountFacet,
  TMemberCounts,
};
export {
  useMemberCounts,
};
